import { useState, useEffect } from 'react'
import Store from '../../Store/Store';
import Request from '../../Request/Request';
import getData from '../../Admin/getData';

export default function Select( props ) {

	const c = props.c
	const data = props.data
	const setData = props.setData

	//console.log( 'select data', data )

	const [ options, setOptions ] = useState( Store.get( 'options-' + props.api ) || [] )
	//const [ optionsList, setOptionsList ] = useState( Store.get( props.api ) || [] )

	function addEmptyElement( d ) {
		//setOptionsList( d )
		//Store.set( props.api, d )
		const o = { [ props.titleKey ]:'', [ props.titleValue ]:'', description:'' }
		//console.log( d )
		const modOptions = d.toSpliced( 0, 0, o )
		Store.set( 'options-' + props.api, modOptions )
		setOptions( modOptions )
	}

	useEffect(() => {
		getData( props.api, null, addEmptyElement )
	}, [ c.column_name, props.api ] )

	return (

		<select 

			style={{ fontSize:15, border:'none' }}
			//onChange={ e => setData( e.target.value ) } 
			value={ props.data[ c.column_name ] || '' }

			onChange={ e => { 
				const d = { ...data }
				d[ c.column_name ] = e.target.value
				setData( d ) 
			} }

		>
			{ options.map( ( r, i ) => <option value={ r[ props.titleKey ] || '' } key={ r[ props.titleKey ] || i }>
				{ r[ props.titleValue ] || '' }
			</option> ) }
		</select>

	)

}